import { combineReducers } from 'redux'
import inductionLog, { State as inductionLogState } from './log'

export interface State {
  inductionLog: inductionLogState
}

export default combineReducers<State>({ inductionLog })
